"use client";

import React from "react";
import { Leaf, Sparkles, HeartHandshake } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const values = [{
  title: "Health",
  description: "Comprehensive OFA clearances for hearts, eyes, and patellas, alongside meticulous DNA evaluations for genetic health and vitality.",
  icon: Leaf
}, {
  title: "Temperament",
  description: "Breeding for the signature 'comforter' personality—gentle, affectionate, and perfectly suited for a lifetime of devotion.",
  icon: HeartHandshake
}, {
  title: "Beauty",
  description: "As AKC Breeders of Merit, we uphold the highest standards of structure and expression to preserve the breed's regal heritage.",
  icon: Sparkles
}];
export default function WhyItsATouchOfLove() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="134382" id="our-philosophy" className="dark bg-background text-foreground py-24 md:py-32 px-6 lg:px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div ref={headerRef} className={`text-center max-w-3xl mx-auto mb-20 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight mb-6 text-foreground">
            Our Royal Philosophy
          </h2>
          <p className="font-sans text-lg md:text-xl text-muted-foreground leading-relaxed">
            Dedicated to the preservation of the Cavalier King Charles Spaniel through the highest standards of health, temperament, and beauty.
          </p>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-3 border-y border-border transition-all duration-1000 delay-200 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {values.map((value, i) => {
          const Icon = value.icon;
          return <div key={i} data-index={i} className="group relative flex flex-col items-center text-center p-10 md:p-14 border-b last:border-b-0 md:border-b-0 md:border-r last:border-r-0 border-border bg-transparent">
                {}
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700 ease-in-out pointer-events-none z-0 flex items-center justify-center">
                  <div className="w-full h-full bg-[radial-gradient(circle_at_center,var(--color-primary)_0%,transparent_60%)] opacity-[0.08] blur-xl rounded-full scale-90 group-hover:scale-100 transition-transform duration-700" />
                </div>

                <div className="relative z-10 flex flex-col items-center">
                  {}
                  <div className="w-20 h-20 rounded-full bg-primary flex items-center justify-center mb-8 shadow-lg shadow-primary/20 group-hover:scale-110 transition-transform duration-500 ease-out">
                    <Icon className="w-10 h-10 text-primary-foreground" strokeWidth={1.5} />
                  </div>

                  <h3 className="font-serif text-2xl md:text-3xl mb-4 text-foreground tracking-wide">
                    {value.title}
                  </h3>
                  
                  <p className="font-sans text-muted-foreground leading-relaxed text-base md:text-lg">
                    {value.description}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}